export const reportTypes: Map<string, string> = new Map([
  ['Negative Delivery Upcharge', 'delivery/negative'],
  ['High Delivery Upcharge', 'delivery/high'],
  ['Low Delivery Upcharge', 'delivery/low'],
  ['Wrong Cents', 'pricing/wrong-cents'],
  ['Zero Price', 'pricing/zero-price'], 
  ['Modifiers: Cheese', 'modifiers/cheese'],
  ['Modifiers: Bacon', 'modifiers/bacon'],
  ['Substitutions', 'substitutions'],
]);
